
import { WOW } from "wowjs";

(function ($) {
	$(document).ready(function () {

		const wow = new WOW();

		wow.init();

		$(".menu-item-has-children").find(".dropdown-toggle").attr("data-toggle", "");

		/**
		 * Mobile Menu - Append translator
		 */
		let translator = $('#google_translate_element');
		let mobileMenu = $('.mobile-menu-wrap');

		if (window.innerWidth < 992) {
			mobileMenu.append(translator);
		}

		/**
		 * Change Forgot Password link
		 */
		$('.login-form form a').attr('href', '/client-login/?action=lostpassword');

		/**
		 * Login form - Add placeholders
		 */
		$('.login-form input[type=text]').attr('placeholder', 'Username');
		$('.login-form input[type=password]').attr('placeholder', 'Password');

		/**
		 * Copyright - Display current year
		 */
		let copyrightYear = new Date().getFullYear()
		$( '#copyright-year' ).text( copyrightYear );

		/**
		 * Back to top button - scroll functionality
		 */
		$("#back-to-top").on("click", function(){
			$("html, body").animate({
				scrollTop: 0,
			}, 400);
		});

		/**
		 * Add class to body when sticky header is showing
		 */
		if ($(window).scrollTop() > 100){
			$('body').addClass('sticky-header');
		} else {
			$('body').removeClass('sticky-header');
		}
		$(window).scroll(function(){
			if ($(window).scrollTop() > 100){
				$('body').addClass('sticky-header');
			} else {
				$('body').removeClass('sticky-header');
			}
		});

		/**
		 * Mobile menu - Open/close functionality
		 */
		var mobileMenuButton = $('.mobile-menu-button');
		var mobileMenuWrap = $('.mobile-menu-wrap ');
		var mobileCloseButton = $('.mobile-menu-close ');
		let mobileMenuBackBtn = $(".mobile-menu-back-btn");

		mobileMenuWrap.find(".mobile-menu > .menu-item-has-children > .sub-menu")
			.addClass("fade");

		mobileMenuButton.on('click', function () {

			$("body").toggleClass("no-scroll");

			mobileMenuWrap.find(".mobile-menu .sub-menu.show")
				.removeClass("show")
				.hide();

			mobileMenuWrap.find(".mobile-menu > .menu-item > .nav-link").css("visibility", "");

			mobileMenuBackBtn.removeClass("show");

			mobileMenuWrap.fadeToggle(400, function(){

				if($(this).is(":hidden")){

					$(".mobile-menu .sub-menu.show", this).removeClass("show");

					mobileMenuBackBtn
						.css("display", "")
						.removeClass("show");

					mobileMenuWrap.find(".mobile-menu > .menu-item-has-children > .sub-menu")
						.css("display", "")
						.removeClass("show");

				}

			});

			return false;

		});

		mobileCloseButton.on('click', function () {

			mobileMenuWrap.fadeOut();

			$("body").toggleClass("no-scroll");

			return false;

		});


		/**
		 * Mobile menu - sub menu functionality
		 */

		// Top level items in dropdown that have a sub menu
		mobileMenuWrap.find(".mobile-menu > .menu-item-has-children > .nav-link").on("click", function(evt){

			evt.preventDefault();

			// Show back button
			mobileMenuBackBtn
				// Add ".show" class first to apply the correct CSS display value
				.addClass("show")
				// Then hide again so that it can be faded in
				.hide()
				.fadeIn(300);

			$(this).siblings(".sub-menu")
				.css("height", $(this).siblings(".sub-menu").outerHeight())
				.show(0, function(){
					$(this).addClass("show");
				});

			setTimeout(function(){
				mobileMenuWrap.find(".mobile-menu > .menu-item > .nav-link").css("visibility", "hidden");
			}, 400);

		});

		mobileMenuBackBtn.on("click", function(){

			$(this)
				.fadeOut(300, function(){
					$(this).removeClass("show");
				});

			mobileMenuWrap.find(".mobile-menu .sub-menu.show")
				.css("height", "")
				.removeClass("show");

			setTimeout(function(){
				mobileMenuWrap.find(".mobile-menu .sub-menu").hide();
			}, 400);

			mobileMenuWrap.find(".mobile-menu > .menu-item > .nav-link")
				.css("visibility", "");

			setTimeout(function(){
				mobileMenuWrap.find(".mobile-menu > .menu-item > .nav-link").fadeTo(300, 1);
			}, 10);


		});
	});
})(jQuery);